// ----------------------------------------------------------------------

export const HEADER = {
  H_MOBILE: 55,
  H_DESKTOP: 55,
  // H_DESKTOP_OFFSET: 70,
};

export const NAV = {
  W_VERTICAL: 280,
  W_MINI: 88,
};
